import type { SpliceRecordCable } from "fond/topologicalView/types";

/**
 * Format an incoming/outgoing cable for display.
 */
export const formatSpliceRecordCable = ({ value, recordCount }: { value?: SpliceRecordCable | null; recordCount: number | undefined }): string => {
  if (value === "dead") {
    return "DEAD";
  }
  if (value === "spare") {
    return recordCount !== undefined ? `SPARE (x${recordCount.toLocaleString()})` : "SPARE";
  }
  return value?.cable.label ?? "";
};
